import React, { useCallback } from 'react';
import { useTranslation } from '@shared/core';
import { EventType } from '@graphql/generated';
import { Search } from '@withjoy/joykit/icons';
import { Flex, IconV2, TextV2 } from '@withjoy/joykit';

import { BannerWrapper, StyledLink } from './SearchBanner.styles';
import { useSearchBannerTelemetry } from './SearchBanner.telemetry';

export interface SearchBannerProps {
  eventType: EventType;
}

const findJoyEventUrl = `${window.location.origin}/find`;

export const SearchBanner: React.FC<SearchBannerProps> = ({ eventType }) => {
  const telemetry = useSearchBannerTelemetry();

  const { t } = useTranslation('createEvent');
  const text = t('searchBanner', 'text');

  const handleFindJoyEvent = useCallback(() => {
    telemetry.findAEventRegistryClicked(eventType);
  }, [telemetry, eventType]);

  return (
    <BannerWrapper alignItems="center" justifyContent="center">
      <StyledLink color="mono14" textAlign="center" lineHeight="22px" fontSize={15} fontWeight={600} textDecoration="none" href={findJoyEventUrl} onClick={handleFindJoyEvent}>
        <Flex>
          <IconV2 size={16}>
            <Search size={16} />
          </IconV2>
        </Flex>
        <Flex>
          <TextV2 textAlign="center" as="p" fontWeight={600} typographyVariant="button1">
            {text()}
          </TextV2>
        </Flex>
      </StyledLink>
    </BannerWrapper>
  );
};
